<template>
  <BookingsBase
    ref="bookingsBase"
    user-type="photographer"
    header-button-icon="arrow_back"
    header-button-color="secondary"
    :header-button-label="$t('bookings.goToPhotographers')"
    @header-button-click="goToPhotographers"
  >
    <template #booking-actions="{ booking, handlers }">
      <q-btn
        v-if="canCancel(booking.status)"
        :label="$t('bookings.dialog.cancel.action')"
        icon="cancel"
        dense
        class="bookings-action-button cancel-btn"
        @click="openCancelDialog(booking, handlers)"
      />
      <q-btn
        v-if="canComplete(booking.status)"
        :label="$t('bookings.dialog.complete.action')"
        icon="check_circle"
        dense
        class="bookings-action-button accept-btn"
        @click="openCompleteDialog(booking)"
      />
    </template>
  </BookingsBase>
</template>

<script>
import BookingsBase from '@/pages/bookings/components/BookingsBase.vue';
import { mapActions, mapState } from 'vuex';
import { notifySuccess, notifyError } from '@/utils/notify';

export default {
  name: 'BookingsOrganizer',
  components: { BookingsBase },
  computed: {
    ...mapState({
      userRole: (state) => state.auth.user?.role,
      wallet: (state) => state.global.wallet,
    }),
    isAuthorizedToModify() {
      return this.userRole === 'organizer' || this.userRole === 'administrator';
    },
  },
  methods: {
    ...mapActions('bookings', ['payoutBooking', 'updateBookingStatus']),
    ...mapActions('global', ['getUserWalletData']),

    async handlePayoutWithStatusChange(bookingId, newStatus, successKey, errorKey) {
      try {
        if (newStatus !== 'completed') {
          throw new Error(errorKey)
        }
          const booking = this.$refs.bookingsBase.allBookings.find(
            (booking) => booking.id === bookingId
          );
          const amountToPayout = booking.rate;
          if (this.wallet < amountToPayout) {
            throw new Error('bookings.insufficientFunds');
          }

         await this.payoutBooking(bookingId);
         notifySuccess(successKey);
      } catch (error) {
        notifyError(
          error?.message === 'bookings.insufficientFunds'
            ? error.message
            : errorKey
        );
      }
    },
    goToPhotographers() {
      this.$router.push({
        name: 'userPanel',
        query: { tab: 'photographers-list' },
      });
    },
    canCancel(status) {
      const isPendingOrAccepted = status === 'pending' || status === 'accepted';
      return isPendingOrAccepted && this.isAuthorizedToModify;
    },
    canComplete(status) {
      return status === 'accepted' && this.isAuthorizedToModify;
    },
    openCancelDialog(booking, handlers) {
      this.$refs.bookingsBase.openDialog(booking, 'cancel', () =>
        handlers.updateStatus(
          booking.id,
          'cancelled',
          'bookings.dialog.cancel.success',
          'bookings.dialog.cancel.error'
        )
      );
    },
    openCompleteDialog(booking) {
      this.$refs.bookingsBase.openDialog(booking, 'complete', () =>
        this.handlePayoutWithStatusChange(
          booking.id,
          'completed',
          'bookings.dialog.complete.success',
          'bookings.dialog.complete.error'
        )
      );
    },
  },
  mounted() {
    this.getUserWalletData();
  },
};
</script>
